(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Product', Product);

  Product.$inject = ['$resource', 'API_URI'];

  function Product($resource, API_URI) {
    var resourceUrl = API_URI + 'api/products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
